import axios from 'axios'

const isDev = (window.location.hostname.includes('localhost')
  || window.location.hostname.includes('dev-net.goplicity'))
const API_URL = isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL_QAS
const API_URL_FLASK = isDev
  ? process.env.REACT_APP_API_URL_FLASK
  : process.env.REACT_APP_API_URL_FLASK_QAS

export const CALLSP = `${API_URL}/CallSP/getSP`

// Server should return an array data
export function callSP(name: string, parameters: any): Promise<any> {
  return axios.post(CALLSP, {
    name,
    parameters,
  })
}

export function callSPUp(name: string, parametersUp: any) {
  return axios.post(CALLSP, {
    name,
    parametersUp,
  })
}

export function axiosApi(url: string, body: any) {
  return axios.post(`${API_URL_FLASK}${url}`, body)
}

export const getFlaskRunPlantilla = (body: any = {}) => {
  return axios.get(`${API_URL_FLASK}Runplantilla/`, {
    params: body,
  })
}

export const getFlaskRunMinuta = (body: any = {}) => {
  return axios.get(`${API_URL_FLASK}Runminuta/`, {
    params: body,
  })
}

export const getFlaskRunCombinado = (body: any = {}) => {
  return axios.get(`${API_URL_FLASK}Runcombinado/`, {
    params: body,
  })
}

export const getFlaskRunHomologado = (body: any = {}) => {
  return axios.get(`${API_URL_FLASK}Runhomologado/`, {
    params: body,
  })
}

export const sendDataiterated = async (amd: string, array_parameter: any, quantity_data_to_sent: number, msj: string, success: (msj: string) => void) => {
  let responseGuarseMinuta: any = null
  let contador = 0
  let contador_estructuras_enviadas = 0
  let data_por_parte: any = []
  let restante = 0
  let cantida_enviada = 0
  for (let index = 0; index < array_parameter.length; index++) {
    contador++
    data_por_parte.push(array_parameter[index])
    if (contador == quantity_data_to_sent) {
      cantida_enviada += quantity_data_to_sent
      contador_estructuras_enviadas++
      responseGuarseMinuta = await callSPUp(amd, data_por_parte)
      if (responseGuarseMinuta.status == 200) {
        success(msj)
      }

      data_por_parte = []
      contador = 0
      restante = (array_parameter.length - cantida_enviada)
    }
    if (restante < quantity_data_to_sent && index == (array_parameter.length - 1)) {
      contador_estructuras_enviadas++
      responseGuarseMinuta = await callSPUp(amd, data_por_parte)
      if (responseGuarseMinuta.status == 200) {
        success(msj)
      }
    }
  }
  return responseGuarseMinuta
}

export const sendDataiterated_callSP = async (amd: string, array_parameter: any, msj: string, success: (msj: string) => void) => {
  let responseGuarseMinuta: any = null
  var array_parameter_length = array_parameter.length
  for (let index = 0; index < array_parameter_length; index++) {
    if (index <= (array_parameter_length - 1)) {
      responseGuarseMinuta = await callSP(amd, array_parameter[index])
      if (responseGuarseMinuta.status == 200) {
        if ((array_parameter_length - 1) == index) {
          success(msj)
        }        
      }
    }
  }
  return responseGuarseMinuta
}